import * as React from 'react';
import classNames from 'classnames';
import Icon from '../Icon';

export interface SearchBarProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  className?: string;
  placeholder?: string;
  hasError?: boolean;
  isDisabled?: boolean;
  innerRef?: React.LegacyRef<HTMLInputElement>;
}

const SearchBar: React.FC<SearchBarProps> = (props: SearchBarProps) => {
  const {
    id,
    className,
    isDisabled,
    hasError,
    innerRef,
    ...otherProps
  } = props;
  const searchBarClass = classNames('ui-searchbar', className);
  const searchBarInputClass = classNames('ui-searchbar-input', {
    'ui-searchbar-input--disabled': isDisabled,
    'ui-searchbar-input--error': hasError,
  });

  return (
    <span className={searchBarClass} id={id}>
      <Icon className="ui-searchbar-icon" name="search" size="x-small" />
      <input
        ref={innerRef}
        type="search"
        className={searchBarInputClass}
        disabled={isDisabled}
        {...otherProps}
      />
    </span>
  );
};

export default SearchBar;
